import * as z from "zod";

export {
  ftthOrchestrator,
  mobileOrchestrator,
  changeMsisdnOrchestrator,
  multiOrderOrchestrator,
  changeSimEsimOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export const verificationErrorResponse = z.object({
  code: z.enum(["50254", "50255"]),
});
